import { Box, Link } from "@mui/material";
import { AlertItem } from "../components/hooks/useTaskAgentState";
import { ReactNode } from "react";

const PartnershipAlertDescription = () => (
  <Box component="span">
    Don't forget! We have a travel partnership with Outfit. Check out{" "}
    <Link
      href="https://advisor.findfaye.com/community/AAAAAAAAUTg%3D"
      target="_blank"
      rel="noopener noreferrer"
      underline="always"
      sx={{
        color: (sx) => sx.palette.primary.main,
      }}
    >
      the community forum
    </Link>{" "}
    for more information
  </Box>
);

const NoMatchingPlaybookAlertDescription = () => (
  <Box component="span">
    Looks like we don't have a playbook yet to pickup that task. Think we
    should?{" "}
    <Link
      href="/tools/agents/playbooks/new"
      target="_blank"
      rel="noopener noreferrer"
      underline="always"
      sx={{
        color: (sx) => sx.palette.primary.main,
      }}
    >
      Create a new playbook
    </Link>
  </Box>
);

const TRAVEL_ALERTS = {
  partnership: {
    id: "partnership_travel_alert",
    title: "Book travel through Outfit",
    description: <PartnershipAlertDescription />,
    level: "info" as const,
  },
};

const SYSTEM_ALERTS = {
  no_matching_playbook: {
    id: "no_playbook",
    title: "No playbook",
    description: <NoMatchingPlaybookAlertDescription />,
    level: "info" as const,
  },
};

export const createAlertsFromDetection = (
  code: "outfit_1" | "no_matching_playbook",
  accountType: "advisor" | "member" = "advisor",
): AlertItem[] => {
  const alerts: AlertItem[] = [];

  if (accountType === "member") {
    return alerts;
  }

  if (code === "outfit_1") {
    alerts.push({
      ...TRAVEL_ALERTS.partnership,
      timestamp: Date.now(),
      dismissed: false,
    });
  } else if (code === "no_matching_playbook") {
    alerts.push({
      ...SYSTEM_ALERTS.no_matching_playbook,
      timestamp: Date.now(),
      dismissed: false,
    });
  }

  return alerts;
};

export const createGenericAlert = (
  title: string,
  description: string,
  level: "info" | "warning" | "error" | "success" = "info",
  id?: string,
): AlertItem => {
  return {
    id: id || `generic_alert_${Math.random().toString(36).substr(2, 9)}`,
    title: title,
    description: (<Box component="span">{description}</Box>) as ReactNode,
    level: level,
    timestamp: Date.now(),
    dismissed: false,
  };
};
